module.exports = __webpack_public_path__ + "static/media/doc.0b9875c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/doc.png
// module id = 73
// module chunks = 0